import request from './request';

export function getUserList(params) {
  return request.get('/users', { params });
}

export function createUser(data) {
  return request.post('/users', data);
}

export function updateUser(id, data) {
  return request.put(`/users/${id}`, data);
}

export function resetUserPassword(id, newPassword) {
  return request.put(`/users/${id}/password`, { newPassword });
}

export function deleteUser(id) {
  return request.delete(`/users/${id}`);
}

export function changeMyPassword(oldPassword, newPassword) {
  return request.put('/users/me/password', { oldPassword, newPassword });
}
